import React, { ReactNode } from 'react';
import styled from 'styled-components';

function Layout({
  children,
}: {
  children: ReactNode;
  themeToggler?: () => void;
}) {
  return <GlobalContainer>{children}</GlobalContainer>;
}

export default React.memo(Layout);

const GlobalContainer = styled.div`
  width: 100%;
  overflow: hidden;
`;
